import React from 'react';
import { NavLink } from 'reactstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ApplicationStatusPage = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const status = searchParams.get('status') || sessionStorage.getItem('status') || 'unknown';
	
	console.log('Application status from URL:', status);

	const handleBackToHome = () => {
		// Clear all necessary items from sessionStorage
		sessionStorage.removeItem('token');
		sessionStorage.removeItem('applicationId');
		sessionStorage.removeItem('name');
		sessionStorage.removeItem('status');
		sessionStorage.removeItem('userId');
		sessionStorage.removeItem('userRole');
		sessionStorage.removeItem('userName');
		// Redirect to login page
		navigate('/login');
	};

	const renderStatusContent = () => {
		switch (status) {
			case 'Submitted':
				return (
					<div className="application_bg">
						<img src="/assets/images/checkgreen.svg" className="img_check_draft" alt="Success" />
						<h3>Application Submitted Successfully</h3>
						<p>Your application has been successfully submitted and is currently under review.</p>
						<ul style={{ textAlign: 'left', marginTop: '20px', lineHeight: '1.8' }}>
							<li>Your application is being reviewed by our evaluation committee</li>
							<li>You will be notified via email about the next steps</li>
							<li>Please check your email regularly for updates</li>
						</ul>
						<ul className="editbutton_list">
							<li>
								<NavLink onClick={handleBackToHome} to="#" className="backhome">
									Back to Home
								</NavLink>
							</li>
						</ul>
					</div>
				);

			case 'Selected':
			case 'Shortlisted':
				return (
					<div className="application_bg">
						<img src="/assets/images/congrats.svg" className="img_check_draft" alt="Congratulations" />
						<h3>🎉 Congratulations! You Have Been Shortlisted</h3>
						<p>Great news! Your application has been shortlisted for the fellowship program.</p>
						<ul style={{ textAlign: 'left', marginTop: '20px', lineHeight: '1.8' }}>
							<li>Your application has been reviewed and shortlisted</li>
							<li>You will receive further instructions via email soon</li>
							<li>Please keep checking your email for next steps</li>
						</ul>
						<ul className="editbutton_list">
							<li>
								<NavLink onClick={handleBackToHome} to="#" className="backhome">
									Back to Home
								</NavLink>
							</li>
						</ul>
					</div>
				);

			case 'Accepted':
				return (
					<div className="application_bg">
						<img src="/assets/images/congrats.svg" className="img_check_draft" alt="Congratulations" />
						<h3>🎊 Congratulations! You Have Been Accepted</h3>
						<p>We are delighted to inform you that you have been accepted into our fellowship program!</p>
						<ul style={{ textAlign: 'left', marginTop: '20px', lineHeight: '1.8' }}>
							<li>Your application has been approved</li>
							<li>Further instructions will be sent to your email</li>
							<li>Welcome to the fellowship program!</li>
						</ul>
						<ul className="editbutton_list">
							<li>
								<NavLink onClick={handleBackToHome} to="#" className="backhome">
									Back to Home
								</NavLink>
							</li>
						</ul>
					</div>
				);

			case 'Rejected':
				return (
					<div className="application_bg">
						<img src="/assets/images/checkgreen.svg" className="img_check_draft" alt="Status Update" />
						<h3>Application Status Update</h3>
						<p>We regret to inform you that your application was not selected for this fellowship program.</p>
						<ul style={{ textAlign: 'left', marginTop: '20px', lineHeight: '1.8' }}>
							<li>After careful consideration, we are unable to offer you a position at this time</li>
							<li>We encourage you to apply again in future cycles</li>
							<li>Thank you for your interest in our program</li>
						</ul>
						<ul className="editbutton_list">
							<li>
								<NavLink onClick={handleBackToHome} to="#" className="backhome">
									Back to Home
								</NavLink>
							</li>
						</ul>
					</div>
				);

			case 'Annexure Received':
				return (
					<div className="application_bg">
						<img src="/assets/images/checkgreen.svg" className="img_check_draft" alt="Documents Received" />
						<h3>Annexure Documents Received</h3>
						<p>Thank you for submitting the required annexure documents.</p>
						<ul style={{ textAlign: 'left', marginTop: '20px', lineHeight: '1.8' }}>
							<li>Your documents have been received and are now being reviewed.</li>
							<li>You will be notified via email about the final outcome.</li>
						</ul>
						<ul className="editbutton_list">
							<li>
								<NavLink onClick={handleBackToHome} to="#" className="backhome">
									Back to Home
								</NavLink>
							</li>
						</ul>
					</div>
				);

			case 'Review 1 - In Progress':
			case 'Review 1 - Completed':
			case 'Review 2 - In Progress':
			case 'Review 2 - Completed':
				return (
					<div className="application_bg">
						<img src="/assets/images/checkgreen.svg" className="img_check_draft" alt="Under Review" />
						<h3>Application Under Review</h3>
						<p>Your application is currently being reviewed by our evaluation committee.</p>
						<ul style={{ textAlign: 'left', marginTop: '20px', lineHeight: '1.8' }}>
							<li>Current Status: {status}</li>
							<li>Our team is carefully evaluating your application</li>
							<li>You will be notified via email once the review is complete</li>
							<li>Please be patient as this process may take some time</li>
						</ul>
						<ul className="editbutton_list">
							<li>
								<NavLink onClick={handleBackToHome} to="#" className="backhome">
									Back to Home
								</NavLink>
							</li>
						</ul>
					</div>
				);

			default:
				return (
					<div className="application_bg">
						<img src="/assets/images/checkgreen.svg" className="img_check_draft" alt="Status" />
						<h3>Application Status</h3>
						<p>Your application status is being processed.</p>
						<ul style={{ textAlign: 'left', marginTop: '20px', lineHeight: '1.8' }}>
							<li>Please check back later for updates</li>
							<li>You will be notified via email for any changes</li>
						</ul>
						<ul className="editbutton_list">
							<li>
								<NavLink onClick={handleBackToHome} to="#" className="backhome">
									Back to Home
								</NavLink>
							</li>
						</ul>
					</div>
				);
		}
	};

	return (
		<div className="container container_cust">
			<div className="application_minh">
				{renderStatusContent()}
			</div>
		</div>
	);
};

export default ApplicationStatusPage;
